/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The ClazzCourseSummaryVo model module.
   * @module clazz_course/model/ClazzCourseSummaryVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>ClazzCourseSummaryVo</code>.
   * @alias module:clazz_course/model/ClazzCourseSummaryVo
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>ClazzCourseSummaryVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/ClazzCourseSummaryVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/ClazzCourseSummaryVo} The populated <code>ClazzCourseSummaryVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'closure')) {
        obj['closure'] = ApiClient.convertToType(data['closure'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'closeTime')) {
        obj['closeTime'] = ApiClient.convertToType(data['closeTime'], 'String');
      }
    }
    return obj;
  }

  /**
   * 班课id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 班课名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 是否结束
   * @member {Boolean} closure
   */
  exports.prototype['closure'] = undefined;
  /**
   * 结束时间
   * @member {String} closeTime
   */
  exports.prototype['closeTime'] = undefined;



  export default exports;
;


